module.exports = __webpack_public_path__ + "static/media/champion.8d9ad604.png";